import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import ExceptionConstants from "../Constants/ExceptionAnalysisConstants";

let getSelectedExcLog = [];
let getAllExcResult = [];
let excDeleteresult = [];
let mulExcDeleteresult = [];
class ExceptionStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getSelectedExceptionResult() {
    return getSelectedExcLog;
  }

  setSelectedExceptionResult(result) {
    getSelectedExcLog = result;
  }

  getAllExceptionResult() {
    return getAllExcResult;
  }

  setAllExceptionResult(result) {
    getAllExcResult = result;
  }

  getExceptionDeleteResult() {
    return excDeleteresult;
  }

  setExceptionDeleteResult(result) {
    excDeleteresult = result;
  }

  getMulExceptionDeleteResult() {
    return mulExcDeleteresult;
  }

  setMulExceptionDeleteResult(result) {
    mulExcDeleteresult = result;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case ExceptionConstants.GET_ALL_EXCEPTION_LOG_SUCCESS:
        this.setAllExceptionResult(action.result);
        break;
      case ExceptionConstants.GET_ALL_EXCEPTION_LOG_FAILURE:
        this.setAllExceptionResult(action.result);
        break;
      case ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_SUCCESS:
        this.setSelectedExceptionResult(action.result);
        break;
      case ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_FAILURE:
        this.setSelectedExceptionResult(action.result);
        break;
      case ExceptionConstants.DELETE_EXCEPTION_SUCCESS:
        this.setExceptionDeleteResult(action.result);
        break;
      case ExceptionConstants.DELETE_EXCEPTION_FAILURE:
        this.setExceptionDeleteResult(action.result);
        break;
      case ExceptionConstants.DELETE_MUL_EXCEPTION_SUCCESS:
        this.setMulExceptionDeleteResult(action.result);
        break;
      case ExceptionConstants.DELETE_MUL_EXCEPTION_FAILURE:
        this.setMulExceptionDeleteResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const exceptionStore = new ExceptionStore();
dispatcher.register(exceptionStore.handleCallback.bind(exceptionStore));
export default exceptionStore;
